import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingsDTO } from '../../common/types/settings';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-visitor-limit',
  templateUrl: './visitor-limit.component.html',
  styleUrl: './visitor-limit.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class VisitorLimitComponent implements OnInit, OnChanges, OnDestroy {
  @Input() settings: SettingsDTO;
  @Output() tabChangedEvent = new EventEmitter();

  visitorLimitForm: FormGroup;
  private formSub: Subscription;

  constructor(private formBuilder: FormBuilder) {
    this.visitorLimitForm = formBuilder.group({
      maxInsiders: [null, Validators.min(0)],
      alertLimit: [null, Validators.min(0)],
    })
  }

  ngOnInit() {
    this.formSub = this.visitorLimitForm.valueChanges.subscribe(value => {
      this.tabChangedEvent.emit(value);
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['settings'] && changes['settings'].currentValue) {
      this.visitorLimitForm.patchValue(changes['settings'].currentValue, { emitEvent: false });
    }
  }

  ngOnDestroy() {
    if (this.formSub) {
      this.formSub.unsubscribe();
    }
  }
}
